import { render, staticRenderFns } from "./404.vue?vue&type=template&id=589d3fe8&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=589d3fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d3fe8",
  null
  
)

export default component.exports